import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=8d7fb39a&scoped=true"
import script from "../js/components/Certificate.js?vue&type=script&lang=js&external"
export * from "../js/components/Certificate.js?vue&type=script&lang=js&external"
import style0 from "./CertificatePage.vue?vue&type=style&index=0&id=8d7fb39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7fb39a",
  null
  
)

export default component.exports